var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransferFill = function SvgTransferFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.515 2.013C17.798 2.28 22 6.65 22 12c0 5.523-4.477 10-10 10l-.515-.013C6.202 21.72 2 17.35 2 12 2 6.477 6.477 2 12 2zM7.667 12.917l5.09 4.095V14.75h4.076v-1.833zm5.088-3.667H7.667v1.833h9.166l-4.078-4.106z",
    clipRule: "evenodd"
  })));
};
export default SvgTransferFill;